<template>
  <expandable-card :height-px="heightPx">
    <template v-slot:title>
      {{ title }}
    </template>
    <template v-slot:subtitle>
      <!--
        EXPLICIT SIZES, NO `small` ELEMENT. ExpandableCard.vue:8 already wraps
        this slot in one, and src/css/components/general.scss:1 sets
        `small { font-size: 0.65em }` — which makes `small` a MULTIPLIER rather
        than a size. Against the 27px card header one level of it resolves to
        17.55px, larger than the 15px article body it introduces; a second
        nested one compounded to 0.65 x 0.65 x 27px = 11.4px, below every size
        token in the app and below any legible floor on a phone.

        An explicit font-size overrides the inherited em computation, which is
        how the sizing contract in 43-UI-SPEC.md is reached without editing
        either shared rule the phase brief deferred. Both values are existing
        Framework7 tokens: --f7-block-header-font-size is 14px (Label) and
        --f7-label-font-size is 12px. This phase authors no new font size, and
        introduces no new `small` element anywhere.

        Inline rather than in a <style> block on purpose: the value has to be in
        the DOM for tests/components/news/NewsCard.test.js to assert the size
        that actually applies. A scoped <style> block is not processed under
        vitest, so those assertions would pass against nothing.
      -->
      <span
          v-if="subtitle"
          class="news-card-subtitle"
          :style="{ fontSize: 'var(--f7-block-header-font-size)', fontWeight: 400 }"
      >{{ subtitle }}</span>
      <!--
        Both the subtitle and its line break are omitted when `subtitle` is
        empty, rather than rendered empty. Legacy rows the composer did not
        create may carry a null subtitle, and an empty element plus a <br> would
        push the hint below a blank line inside a 44px-minimum header.
      -->
      <br v-if="subtitle" />
      <span
          class="news-card-hint"
          :style="{ fontSize: 'var(--f7-label-font-size)', fontWeight: 400, fontStyle: 'italic' }"
      >Open om te lezen</span>
    </template>
    <template v-slot:content>
      <slot name="content"></slot>
    </template>
  </expandable-card>
</template>

<script>

  import ExpandableCard from "../cards/ExpandableCard.vue";
  export default {
    components: {ExpandableCard},

    props: {
      title: {required: true},
      subtitle: {required: false},

      // Passed straight through to ExpandableCard so 43-07 can set it per index
      // without editing this file again: the newest item stays at the shipped
      // 300px and every item after it renders at 140px. The default keeps a
      // one-item list — the overwhelmingly common case — byte-identical to what
      // ships today.
      heightPx: {default: '300px'},
    },

    mixins: [],

    data: function () {
      return {
        //
      };
    },

    computed: {
      //
    },

    created() {
      //
    },

    mounted() {
      //
    },

    methods: {
      //
    },

    watch: {
      //
    }
  };
</script>
<style lang="scss">

</style>
